/* ============================================
   AeroShade — Variant picker (v6 cache-bust)
   Replaces the old variant change handler with reliable
   media-id matching and zero scroll behavior.
   ============================================ */
(() => {
  'use strict';

  function formatMoney(cents) {
    const n = (cents / 100).toFixed(2);
    return '£' + n;
  }

  // Use capture phase to run BEFORE old handler, then stop it
  document.addEventListener('change', async (e) => {
    if (!e.target.matches('[data-variant-input]')) return;
    e.stopImmediatePropagation();

    const form = e.target.closest('form[data-product-form]');
    if (!form) return;

    const productHandle = form.getAttribute('data-product-handle');
    if (!productHandle) return;

    const inputs = form.querySelectorAll('[data-variant-input]:checked');
    const selected = Array.from(inputs).map((i) => i.value);

    let product;
    try {
      const res = await fetch(`/products/${productHandle}.js`);
      product = await res.json();
    } catch (_) { return; }

    const variant = product.variants.find((v) =>
      selected.every((val, i) => v[`option${i + 1}`] === val)
    );
    if (!variant) return;

    // Update hidden id input
    const variantInput = form.querySelector('[name="id"]');
    if (variantInput) variantInput.value = variant.id;

    // Update price
    const priceEl = form.querySelector('[data-variant-price]');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    const wasEl = form.querySelector('[data-variant-compare-price]');
    if (wasEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        wasEl.textContent = formatMoney(variant.compare_at_price);
        wasEl.style.display = '';
      } else {
        wasEl.style.display = 'none';
      }
    }

    // Update ATC button
    const atc = form.querySelector('[data-atc-btn]');
    if (atc) {
      if (variant.available) {
        atc.removeAttribute('disabled');
        atc.textContent = 'ADD TO BAG';
      } else {
        atc.setAttribute('disabled', '');
        atc.textContent = 'SOLD OUT';
      }
    }

    // Update option-display label
    const labelEl = form.querySelector(`[data-option-display="${e.target.name}"]`);
    if (labelEl) labelEl.textContent = e.target.value;

    // If variant has NO image AND there's a sister product for that color, navigate to it
    const COLOR_TO_HANDLE = {
      'Camouflage': 'aeroshade-aeris-camouflage-frame',
      'Transparent': 'aeroshade-aeris-crystal-clear-frame',
      'Black': 'aeroshade-aeris-triple-black-frame'
    };
    const selectedColor = e.target.value;
    const sisterHandle = COLOR_TO_HANDLE[selectedColor];
    const variantHasImage = (variant.featured_media && variant.featured_media.id)
                           || (variant.featured_image && variant.featured_image.id);
    if (sisterHandle && sisterHandle !== productHandle && !variantHasImage) {
      // No image on this product for that color, but a sister product exists — go there
      window.location.href = '/products/' + sisterHandle;
      return;
    }

    // SWAP GALLERY IMAGE — reliable media-id matching
    // Looks for tiles with data-media-id matching variant's featured_media.id
    // Restores original order if no match (returns to original first image)
    const gallery = document.querySelector('[data-pdp-gallery]');
    if (!gallery) return;

    // Stash original order on first run
    if (!gallery.dataset.originalOrder) {
      const ids = Array.from(gallery.querySelectorAll('[data-media-id]'))
        .map((el) => el.getAttribute('data-media-id'));
      gallery.dataset.originalOrder = JSON.stringify(ids);
    }

    let targetMediaId = null;
    if (variant.featured_media && variant.featured_media.id) {
      targetMediaId = String(variant.featured_media.id);
    } else if (variant.featured_image && variant.featured_image.id) {
      targetMediaId = String(variant.featured_image.id);
    }

    if (targetMediaId) {
      const matchedTile = gallery.querySelector(`[data-media-id="${targetMediaId}"]`);
      if (matchedTile && matchedTile !== gallery.firstElementChild) {
        gallery.insertBefore(matchedTile, gallery.firstElementChild);
      }
    } else {
      // No specific image for this variant — restore original first image
      try {
        const origIds = JSON.parse(gallery.dataset.originalOrder);
        if (origIds.length > 0) {
          const firstOrigTile = gallery.querySelector(`[data-media-id="${origIds[0]}"]`);
          if (firstOrigTile && firstOrigTile !== gallery.firstElementChild) {
            gallery.insertBefore(firstOrigTile, gallery.firstElementChild);
          }
        }
      } catch (_) {}
    }

    // No scroll, no URL change — just visual swap
  }, true); // capture phase
})();
